/** Eksportene under «festival» i katalogen (docs/EKSPORT.md §9). API-halvdelen: `apps/api/src/export/definitions/festival/`. */
import type { ExportMeta } from '../types.js';

/**
 * ADVANCE: ett dokument per programpost, satt sammen av fanene på programposten.
 * Fra programposten (`object`), fra merkede rader i lineupen (`selection`), og alle i lineupen
 * (`parent` = årgangen).
 */
const ADVANCE: ExportMeta = {
  id: 'festival.advance',
  domain: 'festival',
  kind: 'document',
  titleKey: 'export.festival.advance.title',
  formats: ['pdf', 'docx', 'csv'],
  scopes: ['object', 'selection', 'parent'],
  requires: ['performance:read'],
  guest: true,
  sections: [
    { key: 'times', labelKey: 'export.festival.advance.sections.times' },
    { key: 'party', labelKey: 'export.festival.advance.sections.party' },
    { key: 'travel', labelKey: 'export.festival.advance.sections.travel' },
    { key: 'stay', labelKey: 'export.festival.advance.sections.stay' },
    { key: 'local', labelKey: 'export.festival.advance.sections.local' },
    { key: 'technical', labelKey: 'export.festival.advance.sections.technical' },
    { key: 'hospitality', labelKey: 'export.festival.advance.sections.hospitality' },
    /* Promo-seksjonen og organisasjonens egne advance-seksjoner: skjermen viser dem, så eksporten gjør det. */
    { key: 'promo', labelKey: 'export.festival.advance.sections.promo' },
    { key: 'diet', labelKey: 'export.festival.advance.sections.diet' },
    { key: 'guests', labelKey: 'export.festival.advance.sections.guests' },
    { key: 'contacts', labelKey: 'export.festival.advance.sections.contacts' },
    { key: 'documents', labelKey: 'export.festival.advance.sections.documents' },
    {
      key: 'contract',
      labelKey: 'export.festival.advance.sections.contract',
      requires: ['contract:read'],
    },
  ],
  params: ['editionId'],
};

/**
 * HOTELLISTE (liste på tvers, EKSPORT.md §4): alle rom, netter, navn og romtype i årgangen, sortert
 * på hotell og dato. Fra Oppsummering › Overnatting og fra lineupen.
 */
const HOTEL_LIST: ExportMeta = {
  id: 'festival.hotel-list',
  domain: 'festival',
  kind: 'table',
  titleKey: 'export.festival.hotelList.title',
  formats: ['pdf', 'docx', 'csv'],
  scopes: ['parent', 'selection'],
  requires: ['performance:list'],
  guest: false,
  columns: [
    { key: 'hotel', labelKey: 'export.festival.hotelList.columns.hotel', type: 'text' },
    { key: 'checkIn', labelKey: 'export.festival.hotelList.columns.checkIn', type: 'date' },
    { key: 'checkOut', labelKey: 'export.festival.hotelList.columns.checkOut', type: 'date' },
    { key: 'nights', labelKey: 'export.festival.hotelList.columns.nights', type: 'integer' },
    { key: 'roomNumber', labelKey: 'export.festival.hotelList.columns.roomNumber', type: 'text' },
    { key: 'roomType', labelKey: 'export.festival.hotelList.columns.roomType', type: 'text' },
    { key: 'guests', labelKey: 'export.festival.hotelList.columns.guests', type: 'multiline' },
    { key: 'forWhom', labelKey: 'export.festival.hotelList.columns.forWhom', type: 'text' },
    {
      key: 'bookingReference',
      labelKey: 'export.festival.hotelList.columns.bookingReference',
      type: 'text',
    },
    {
      key: 'hotelContact',
      labelKey: 'export.festival.hotelList.columns.hotelContact',
      type: 'text',
      defaultHidden: true,
    },
    {
      key: 'hotelPhone',
      labelKey: 'export.festival.hotelList.columns.hotelPhone',
      type: 'phone',
      defaultHidden: true,
    },
    {
      key: 'hotelAddress',
      labelKey: 'export.festival.hotelList.columns.hotelAddress',
      type: 'text',
      defaultHidden: true,
    },
  ],
  params: ['editionId'],
  landscape: true,
};

export const FESTIVAL_EXPORTS: readonly ExportMeta[] = [ADVANCE, HOTEL_LIST];
